const ENSystemConnections = {
	"Conexões do Sistema": "System Connections",
	"Conexões do sistema": "System connections",
	"Última Verificação": "Last Check",
	"Exclusão de Conexão": "Delete Connection",
	"Deseja realmente excluir esta conexão": "Do you really want to delete this connection",
	"Data de expiração": "Expiration date"
};

export default ENSystemConnections;
